import axios from 'axios';

export default {
  getMonthDataOfRMVA: (year) => axios.get(`/api/v1/avg/energie-wate/month-data-of-rmva/${year}`),
  getByYear: (year) => axios.get(`/api/v1/avg/energie-wate/${year}`),
  create: (params) => axios.post('/api/v1/avg/energie-wate', params),
  update: (params) => axios.put('/api/v1/avg/energie-wate', params),
};
